/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type SubmitHardwareRequestMutationVariables = Types.Exact<{
  id: Types.Scalars["Float"];
}>;

export type SubmitHardwareRequestMutation = {
  submitHardwareRequest: Pick<
    Types.HardwareRequest,
    "id" | "status" | "requested_at"
  >;
};

export const SubmitHardwareRequestDocument = gql`
  mutation SubmitHardwareRequest($id: Float!) {
    submitHardwareRequest(id: $id) {
      id
      status
      requested_at
    }
  }
`;

/**
 * __useSubmitHardwareRequestMutation__
 *
 * To run a mutation, you first call `useSubmitHardwareRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitHardwareRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitHardwareRequestMutation, { data, loading, error }] = useSubmitHardwareRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSubmitHardwareRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    SubmitHardwareRequestMutation,
    SubmitHardwareRequestMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    SubmitHardwareRequestMutation,
    SubmitHardwareRequestMutationVariables
  >(SubmitHardwareRequestDocument, baseOptions);
}
export type SubmitHardwareRequestMutationHookResult = ReturnType<
  typeof useSubmitHardwareRequestMutation
>;
export type SubmitHardwareRequestMutationResult =
  ApolloReactCommon.MutationResult<SubmitHardwareRequestMutation>;
export type SubmitHardwareRequestMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    SubmitHardwareRequestMutation,
    SubmitHardwareRequestMutationVariables
  >;
